import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProtocolsState } from './protocols.reducer';

export const selectProtocolsState = createFeatureSelector<ProtocolsState>('protocols');

export const selectProtocols = createSelector(selectProtocolsState, state => state.items);

export const selectProtocolsContinuationToken = createSelector(selectProtocolsState, state => state.continuationToken);

export const selectProtocolsLoading = createSelector(selectProtocolsState, state => state.loading);
